import { createOutlet } from './Outlet';
export function map(outletDescriptor, mapFn) {
    var last;
    return createOutlet({
        getCurrentValue: function () {
            var currentValue = outletDescriptor.getCurrentValue();
            if (!last || currentValue !== last.value) {
                last = {
                    value: currentValue,
                    mappedValue: mapFn(currentValue),
                };
            }
            return last.mappedValue;
        },
        hasCurrentValue: outletDescriptor.hasCurrentValue,
        subscribe: outletDescriptor.subscribe,
    });
}
//# sourceMappingURL=map.js.map